import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AnimationService } from 'src/app/utils/animation.service';

@Component({
  selector: 'app-intro-options',
  templateUrl: './intro-options.component.html',
  styleUrls: ['../home.component.scss', './intro-options.component.scss']
})
export class IntroOptionsComponent implements OnInit {
  
  @ViewChild('animation')
  animation: ElementRef;

  constructor(private animations: AnimationService) { }

  ngOnInit(): void {
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
    this.animations.startRightToLeftAnimation(this.animation.nativeElement);
  }
}
